<template>
    <div class="card">
        <div class="card-header bg-info">
            <h3 class="my-0">Configuración PSE</h3>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-12">
                    <el-switch v-model="form.send_document_to_pse"
                               :disabled="true"
                               active-text="Firmar Xml"
                               inactive-text=""></el-switch>
                </div>
                <div class="col-md-12">
                    <el-switch v-model="form.send_document_to_pse_ose"
                               :disabled="true"
                               active-text="Enviar a OSE"
                               inactive-text=""></el-switch>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'PseConfiguration',
    data() {
        return {
            resource: 'companies',
            form: {},
        }
    },
    async created() {
        this.initForm()
        await this.getData()
    },
    methods: {
        initForm() {
            this.form = {
                send_document_to_pse: false,
                send_document_to_pse_ose: false,
            }
        },
        async getData() {
            await this.$http.get(`/${this.resource}/record-send-pse`)
                .then(response => {
                    this.form = response.data
                })
        },
    }
}
</script>
